import { setTokenToAxios, TSetSession, TLeaderBoardUser } from '../axios';
import { AuthProviderEnum, TAuthProvider } from '@onesource/schemas';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import {
  clearAuthProvider,
  getActiveAuthProvider,
  REFRESH_TOKEN_STORAGE_KEY,
  SESSION_STORAGE_KEY,
  USER_STORAGE_KEY,
  setActiveAuthProvider,
} from './auth-provider-utils';

export const getSession = (): string | null => {
  return localStorage.getItem(SESSION_STORAGE_KEY);
};

export const getRefreshToken = (): string | null => {
  return localStorage.getItem(REFRESH_TOKEN_STORAGE_KEY);
};

export interface TSetSessionWithProvider extends TSetSession {
  authProvider?: TAuthProvider;
  refreshToken?: string;
}

export const setSession = (param: TSetSessionWithProvider) => {
  const { token, user, authProvider, refreshToken } = param;
  localStorage.setItem(SESSION_STORAGE_KEY, token);
  localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user));

  if (refreshToken) {
    localStorage.setItem(REFRESH_TOKEN_STORAGE_KEY, refreshToken);
  }

  // Store auth provider if specified
  if (authProvider) {
    setActiveAuthProvider(authProvider);
  }

  setTokenToAxios(token);
};

export const getUser = (): TLeaderBoardUser | null => {
  const user = localStorage.getItem(USER_STORAGE_KEY);
  return user ? JSON.parse(user) : null;
};

export const isLoggedIn = (): boolean => {
  const session = getSession();
  return !!session;
};

export const getAuthProvider = (): TAuthProvider => {
  return getActiveAuthProvider();
};

export const logout = async () => {
  // Call sign-out API if using Supabase auth
  const currentProvider = getActiveAuthProvider();
  if (currentProvider === AuthProviderEnum.supabase) {
    try {
      const token = getSession();
      if (token) {
        const rawAxios = axios.create({ baseURL: API_BASE_URL });
        await rawAxios.post(
          '/auth/sign-out',
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'x-auth-provider': 'supabase',
            },
          },
        );
      }
    } catch (error) {
      console.error('Failed to sign out:', error);
    }
  }

  // Preserve auth_provider so the login page renders the correct form.
  // Callers that need to reset the provider (e.g. resetProvider, switchProvider)
  // call clearAuthProvider() or setActiveAuthProvider() explicitly.
  clearAuthProvider({ keepProvider: true });
};
